import { LinkHelper } from '@/Services';
import { User } from '@/Services/Auth/types';
import { UserRoleEnum } from '@/Types/api/User';

export const createUserDefaultUrlPage = (user?: User): string => {
    const roleKey = user?.role?.key;

    let navigatePath = LinkHelper.dashboard;

    if (roleKey === UserRoleEnum.PRODUCT_MANAGER) {
        navigatePath = LinkHelper.productProposals;
    } else if (roleKey === UserRoleEnum.SERVICE_ENGINEER) {
        navigatePath = LinkHelper.iRomaScentsStations;
    } else if (roleKey === UserRoleEnum.SERVICE_PROVIDER) {
        if (user?.sp_cluster) {
            navigatePath = LinkHelper.serviceProvider.storeClusterServiceProviderDashboard;
        } else {
            navigatePath = LinkHelper.myPage;
        }
    }

    return navigatePath;
};

export const navigateUserToDefaultPage = (user?: User): void => {
    window.location.href = createUserDefaultUrlPage(user);
};
